import { RegisterService } from './../../../../services/cms/register.service';
import { CookieService } from './../../../../services/core/cookie/cookie.service';
import { ApiService } from './../../../../services/core/api.service';
//Angular
import { Component, OnInit, ViewContainerRef, ChangeDetectionStrategy, ViewEncapsulation, Compiler, Inject, Renderer } from "@angular/core";

//System
import { Mappings } from './../../../../shared/mapping';

//Service
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { LoginService } from "../../../../services/cms/login.service";
import { AuthService } from "../../../../services/core/auth.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { Router, ActivatedRoute } from "@angular/router";
import { RecoverPasswordService } from "../../../../services/cms/recover-password.service";
import { CmsComponentService } from "../../../../services/cms/cms-component.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { SeoService } from "../../../../services/core/seo.service";
import { Meta } from '../../../../services/core/angular2-meta';
import { HeaderService } from '../../../../services/cms/header.service';
//Models
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';
import { SeoViewModel } from "../../../../models/core/seo";
import { UserLogin } from './../../../../models/cms/user-login';
import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';


@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class UserLoginComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsService: CmsComponentService,
            private seo: SeoService,
            @Inject(DOCUMENT) private document: any,
            private renderer: Renderer,
            @Inject('isBrowser') private isBrowser: boolean,
            private scriptService: ScriptService
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        let loginData: string;
        let header: any;
        let headDataSub = this.cmsService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        // this.templateService.getComponentTemplate("userLoginPageTemplate").subscribe(result =>
        let loginSub = this.cmsService.getLoginPageData().subscribe(result => {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (this.isBrowser) {
                loginData = result;

                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(loginData, header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.loginId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(loginSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(loginData: any, header: any) {
        @Component({
            template: loginData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private mappings: Mappings,
                    private loginService: LoginService,
                    private _elementRef: ViewContainerRef,
                    private authService: AuthService,
                    private scriptService: ScriptService,
                    private routesService: RoutesService,
                    private router: Router,
                    private route: ActivatedRoute,
                    private seoService: SeoService,
                    private recoverPasswordService: RecoverPasswordService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private breadcrumbsService: BreadcrumbsService,
                    private api: ApiService,
                    @Inject('CookieService') private cookie: CookieService,
                    private registerService: RegisterService,
                    private headerService: HeaderService,
                    private metaService: Meta
                ) {
                if (!this.isBrowser || this.constructorIsInit) {
                    return;
                }


                this.constructorIsInit = true;
            }

            private breadcrumbs: Breadcrumbs[] = loginData.BreadcrumbsInfo;

            footerData: any = loginData.footerData;
            headerData: any = header;
            private countFb=0;
            private showSpinnerClick: boolean = false;
            private userLoginUrl: string = this.mappings.UserLoginImg_Url;
            private userNotActive: boolean;
            private userNotFound: boolean;
            private pageFrom: string = "";
            private emailError: boolean = false;
            private passwordError: boolean = false;
            private seoInfo: SeoViewModel = loginData.SeoInformation;
            private recoverPasswordFailed: boolean;
            private recoverPasswordSuccess: boolean;
            private emailErrorRecover: boolean = false;
            private pageIsInit: boolean = false;
            private constructorIsInit: boolean = false;
            private isActiveFacebookModule: boolean = loginData.isActiveFacebookModule;
            private model = {
                Email: "",
                Password: ""
            };

            private modelRecover =
                {
                    Email: ""
                };

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                let paramsSub = this.route.params.subscribe(params => {
                    let paramPageFrom = params['pagefrom'];

                    if (paramPageFrom !== undefined) {
                        this.pageFrom = paramPageFrom;
                    }
                });

                this.subManager.add(paramsSub);
            }

            onFacebookLoginClick() {

                FB.login((result: any) => {
                    this.getUserInfoFromFb();
                }, { scope: 'email' });

                this.getUserFromFb();
            }

            getUserFromFb() {
                let email = this.cookie.get("emailFbUser");
                let firstName = this.cookie.get("firstNameFbUser");
                let lastName = this.cookie.get("lastNameFbUser");
                if (email != undefined && firstName != undefined && lastName != undefined) {
                    let authSub = this.loginService.authentificateUser(email, firstName, lastName).subscribe(response => {
                        this.cookie.remove("emailFbUser");
                        this.cookie.remove("firstNameFbUser");
                        this.cookie.remove("lastNameFbUser");

                        // if(response.Active)
                        // {
                        this.authService.Login(response.Id_User_Dettail, response.Name);
                        // }                        
                        if (response.IsCompletedRegistration == false) {
                            if (response.Active) {
                                this.registerService.setFacebookLoginData(response);
                                //update after login the header information
                                let user = new UserLogin();
                                user.isAuthenticated = true;
                                user.username = response.Name ? response.Name : this.model.Email;
                                this.headerService.setLoggedInUser(user);
                                this.router.navigate(this.routesService.getRoutePath('REGISTRAZIONE'));
                            }
                            else {
                                this.userNotActive = false;
                                this.userNotFound = false;
                            }
                        }
                        else if (this.pageFrom == "cart") {
                            //update after login the header information
                            let user = new UserLogin();
                            user.isAuthenticated = true;
                            user.username = response.Name ? response.Name : this.model.Email;
                            this.headerService.setLoggedInUser(user);
                            //this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                            (window as any).open(this.routesService.getRoutePath('CARRELLO'), "_self");
                        }
                        else {
                            this.router.navigate(this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));
                        }

                    });

                    this.subManager.add(authSub);
                }
                else {
                    setTimeout(x => this.getUserFromFb(), 200);
                }
            }

            getUserInfoFromFb() {
                FB.api('/me?fields=first_name,last_name,email',
                    function (result) {
                        if (result && !result.error) {
                            let email = result.email;
                            let firstName = result.first_name;
                            let lastName = result.last_name;
                            document.cookie = "emailFbUser=" + email + ";";
                            document.cookie = "firstNameFbUser=" + firstName + ";";
                            document.cookie = "lastNameFbUser=" + lastName + ";";
                        } else {
                            console.log(result.error);
                        }
                    }
                );
            }

            onSubmit(form) {
                if (form.valid) {
                    this.showSpinnerClick=true;
                    this.emailError = false;
                    this.passwordError = false;
                    let loginDataSub = this.loginService.sendLoginRequest(this.model.Email, this.model.Password).subscribe(result => {
                        if (result.Id_User_Dettail > 0) {
                            if (result.Active) {
                                this.authService.Login(result.Id_User_Dettail, result.Name);

                                //update after login the header information
                                let user = new UserLogin();
                                user.isAuthenticated = true;
                                user.username = result.Name ? result.Name : this.model.Email;
                                this.headerService.setLoggedInUser(user);

                                if (this.pageFrom == "cart") {
                                    //this.router.navigate(this.routesService.getRoutePath('CARRELLO'));
                                    (window as any).open(this.routesService.getRoutePath('CARRELLO'), "_self");
                                }

                                else {
                                    this.router.navigate(this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE'));

                                }
                            }
                            else {
                                this.userNotActive = false;
                                this.userNotFound = false;
                            }
                        }

                        else {
                            this.userNotActive = false;
                            this.userNotFound = true;
                        }
                        this.showSpinnerClick=false;
                    })

                    this.subManager.add(loginDataSub);
                }

                else if (!form.valid) {
                    if (form.form.controls.password.valid == false) {
                        this.passwordError = true;
                    }

                    else if (form.form.controls.password.valid == true) {
                        this.passwordError = false;
                    }

                    if (form.form.controls.email.valid == false) {
                        this.emailError = true;
                    }

                    else if (form.form.controls.email.valid == true) {
                        this.emailError = false;
                    }
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                let fbCode = loginData.FacebookAppID;
                this.initFacebook(fbCode)

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                // Eventually retrieving the script to append
                // if (this.seoInfo.HasScripts == true) {
                //     this.scriptService.appendLoginScript(this._elementRef.element.nativeElement);
                // }

                this.pageIsInit = true;
            }
            initFacebook(fbCode) {
                try {
                    this.countFb = this.countFb + 1;
                    FB.init({
                        appId: fbCode,
                        cookie: false,
                        xfbml: false,
                        version: 'v2.5'
                    });
                } catch (e) {
                    if (this.countFb <= 5) {
                        setTimeout(x => this.initFacebook(fbCode), 1);
                    }
                }
            }
            
            recoverPassword(form) {
                if (form.valid) {
                    this.showSpinnerClick=true;
                    this.emailErrorRecover = false;
                    let recoverPassSub = this.recoverPasswordService.recoverPasswordRequest(this.modelRecover.Email).subscribe(result => {
                        if (result.selected) {
                            this.modelRecover.Email = "";

                            this.recoverPasswordFailed = false;
                            this.recoverPasswordSuccess = true;
                        }
                        else {
                            this.recoverPasswordFailed = true;
                            this.recoverPasswordSuccess = false;
                        }
                        this.showSpinnerClick=false;
                    });

                    this.subManager.add(recoverPassSub);
                }

                else if (!form.valid) {
                    if (form.form.controls.email.valid == false) {
                        this.emailErrorRecover = true;
                    }
                }
            }


            ngOnDestroy() {
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/user/sys/user-login.component.ts